import { useSettings } from '@capsicum/common';
import { useSocialFeedPartnersQuery } from '@capsicum/features/feeds/shared';
import { useMemo } from 'react';

type UseEventsPerPartnerProps = {
	disabled?: boolean;
	partnerIds: Array<string>;
};

const EVENTS_LIMIT = 100;

export const useEventsPerPartner = ({ disabled, partnerIds }: UseEventsPerPartnerProps) => {
	const {
		settings: { showAvailableFanZoneActivitiesIndicator }
	} = useSettings();
	const { data: feedPerPartner } = useSocialFeedPartnersQuery(
		{
			'activityTypes[]': [
				'backoffice_form',
				'survey_engagement_poll',
				'wp_image_published_typeform',
				'survey_integrity_poll'
			],
			feedSlug: 'partner_page',
			partnerIds,
			partnerLimit: EVENTS_LIMIT
		},
		{ enabled: showAvailableFanZoneActivitiesIndicator && !disabled && partnerIds.length > 0 }
	);

	const eventsPerPartner = useMemo(
		() =>
			feedPerPartner?.reduce(
				(acc, partner) => {
					if (partner.feed) {
						acc[partner.partnerId] = partner.feed.length;
					}

					return acc;
				},
				{} as Record<string, number>
			),
		[feedPerPartner]
	);

	const getFormattedEventNumber = (events: number) => {
		return events > EVENTS_LIMIT - 1 ? `${EVENTS_LIMIT - 1}+` : events.toString();
	};

	return {
		eventsPerPartner,
		getFormattedEventNumber
	};
};
